/* eslint-disable react/display-name */
import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import styles from './DirectorName.module.css';
import PureInput from '../../PureInput';

function DirectorName(props) {
    const { firstNameField, lastNameField } = props;

    return ({ openSearchMenu, closeSearchMenu, setNewSearchTerm }) => {
        const inputProps = (field, otherNameField) => ({
            onFocus: (e) => {
                openSearchMenu();
                field.onFocus(e);
            },
            onBlur: (e) => {
                closeSearchMenu();
                field.onBlur(e);
            },
            handleChange: (e, formatter) => {
                setNewSearchTerm(
                    {
                        [field.name]: formatter
                            ? formatter(e.target.value)
                            : e.target.value,
                        [otherNameField.name]: otherNameField.value
                    },
                    {
                        getNewOptions: true
                    }
                );
                field.onChange(e);
            },
            onClick: openSearchMenu
        });
        const firstNameProps = inputProps(firstNameField, lastNameField);
        const lastNameProps = inputProps(lastNameField, firstNameField);
        return (
            <div className={styles.DirectorName}>
                <PureInput
                    placeholder="First name"
                    maxLength={100}
                    whenBlur={(event) => {
                        if (event.target.value.length > 0) {
                            tracking.ampli.formFieldCompleted({
                                form_field: 'first_name'
                            });
                        }
                    }}
                    {...firstNameField}
                    {...firstNameProps}
                />

                <PureInput
                    placeholder="Last name"
                    whenBlur={(event) => {
                        if (event.target.value.length > 0) {
                            tracking.ampli.formFieldCompleted({
                                form_field: 'last_name'
                            });
                        }
                    }}
                    maxLength={100}
                    {...lastNameField}
                    {...lastNameProps}
                />
            </div>
        );
    };
}

export default DirectorName;
